import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '9.1049 4.115'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M17.7899 0H0.419922C3.60992 6.93 7.05993 8.23 9.09993 8.23C11.1399 8.23 14.5999 6.94 17.7899 0Z"
          fill={outline}
        />
        <path
          d="M17.1099 0.620117C17.1099 0.620117 14.2799 2.02011 9.10986 2.02011C3.93986 2.02011 1.10986 0.620117 1.10986 0.620117C4.04986 4.78012 7.22986 5.56011 9.10986 5.56011C10.9899 5.56011 14.1699 4.79012 17.1099 0.620117Z"
          fill="white"
        />
      </g>
    </g>
  )
}
